import { type ProviderConfiguration, type PaymentProviderConfiguration, type LoyaltyProviderConfiguration, type FeedbackProviderConfiguration } from "../configuration/ProviderConfiguration";
import { type PosProviderConfiguration } from "../configuration/PosProviderConfiguration";
import { AppType } from "../enums/AppType";
import { DeviceOrientation } from "../enums/DeviceOrientation";
import { AuthenticationConfiguration } from "../configuration/AuthenticationConfiguration";

export interface Location {
    id?: string;
    brandId: string;
    organizationId?: string;
    name: string;
    slug?: string;
    salesforceId: string;
    type?: number;
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    country?: string;
    timeZoneId?: string;
    currency?: string;
    locale?: string;
    phoneNumber?: string;
    email?: string;
    enabled: boolean;
    // Set (server-side) the first time a location is ever enabled; never cleared. Distinct from `enabled`
    // so a re-disabled location still reads as "has been onboarded".
    firstEnabledAt?: string | null;
    // Set (server-side) each time an onboarding email is sent; overwritten on re-send. Null = never sent.
    onboardingEmailSentAt?: string | null;
    licensedApps: App[];
    restaurant?: Restaurant;
    retail?: Retail;
    posConfiguration?: PosProviderConfiguration | undefined | null;
    paymentConfiguration?: PaymentProviderConfiguration | undefined | null;
    pmsConfiguration?: ProviderConfiguration | undefined | null; // TODO: we may need to subclass this if there are specific properties for PMS providers
    loyaltyConfiguration?: LoyaltyProviderConfiguration | undefined | null;
    feedbackConfiguration?: FeedbackProviderConfiguration | undefined | null;
    authenticationConfiguration?: AuthenticationConfiguration | undefined | null;
}

export const RestaurantType = {
  None: 0,
  DineIn: 1,
  QuickService: 2,
  Catering: 4,
  Bar: 8,
  FoodTruck: 16,
  HotelVenue: 32
} as const;

export interface Restaurant {
    types: number;
    // Tip fields moved to the TipConfiguration model (brand/group/location scope), managed in Configuration -> Tips.
}

export interface Retail {
    storeHours?: string;
}

export interface App {
    type: AppType;
    defaultOrientation: DeviceOrientation;
}

// Location fields that are explicitly OPTIONAL per the backend readiness check (PortalAPI
// LocationService.BuildReadiness: "Phone and Email are optional for a location"; address2 is a second
// address line). They must never gate enablement and must not count toward onboarding progress — else a
// location can never reach 100% / leave the onboarding list. Everything else the client fills is required.
// (The required (*) markers on LocationDetails are set per-field to mirror that same readiness list.)
export const OPTIONAL_LOCATION_FIELDS = ['address2', 'phoneNumber', 'email'] as const;

//export interface ProviderConfiguration {
//    locationId: string;
//    externalId: string;
//    kind: number;
//    vendor: string;
//    version: string;
//    configurationJson: string;
//}

export function createLocation(locationType: number, organizationId: string, brandId: string): Location {
    return {
        id: undefined,
        organizationId: organizationId,
        brandId: brandId,
        name: '',
        slug: undefined,
        salesforceId: '',
        type: locationType,
        address1: undefined,
        address2: undefined,
        city: undefined,
        state: undefined,
        postalCode: undefined,
        phoneNumber: undefined,
        email: undefined,
        timeZoneId: undefined,
        enabled: false,
        licensedApps: [],
        posConfiguration: null,
        paymentConfiguration: null,
        pmsConfiguration: null,
        loyaltyConfiguration: null,
        feedbackConfiguration: null
    };
}

        //     posConfiguration: {
        //    locationId: "",
        //    kind: 0,
        //    externalId: "",
        //    vendor: "",
        //    version: "",
        //    configurationJson: "",
        //    endServiceChargeToPos: false,
        //    autoCloseCheck: false,
        //    checkRetrievalTimePeriodMinutes: 0
        //},
        //paymentConfiguration: {
        //    locationId: "",
        //    kind: 1,
        //    externalId: "",
        //    vendor: "",
        //    version: "",
        //    configurationJson: "",
        //    paymentMethodsAccepted: 0,
        //    allowGiftCardTipping: false
        //},
        //pmsConfiguration: {
        //    locationId: "",
        //    kind: 2,
        //    externalId: "",
        //    vendor: "",
        //    version: "",
        //    configurationJson: "",
        //},
        //loyaltyConfiguration: {
        //    locationId: "",
        //    kind: 3,
        //    externalId: "",
        //    vendor: "",
        //    version: "",
        //    configurationJson: "",
        //},
        //feedbackConfiguration: {
        //    locationId: "",
        //    kind: 4,
        //    externalId: "",
        //    vendor: "",
        //    version: "",
        //    configurationJson: "",
        //}